import {
	registerPageContextProvider,
	registerSuggestionsProvider,
} from '@/features/ai/registry'

import { getCaseBubbles } from './constants'
import { useCasePageContext } from './hooks/use-case-page-context'

/**
 * Side-effect registration for AIR® AI bindings on the case-detail route.
 *
 * Side-effect imported by `src/routes/_dashboard/air/case-management.$id.tsx`.
 * Registers under `'case_detail'` (the literal returned by
 * `useCasePageContext` when `$id` is present).
 *
 * "Open in Search" navigation is no longer routed through the registry —
 * `<OpenInSearchCard>` resolves it inline via `useNavigate()`.
 */

registerPageContextProvider('case_detail', useCasePageContext)
registerSuggestionsProvider('case_detail', getCaseBubbles)
